import 'css-chunksrc/client/scenes/listRemoval/listsList/list/milestone/styles.scss';export default {
  "milestone": "_milestone_i56hf_1",
  "contextualMenu": "_contextualMenu_i56hf_8",
  "milestoneDetails": "_milestoneDetails_i56hf_12",
  "name": "_name_i56hf_22",
  "icon": "_icon_i56hf_38",
  "taskAdvancement": "_taskAdvancement_i56hf_42",
  "taskAdvancementWrapper": "_taskAdvancementWrapper_i56hf_48",
  "removeIcon": "_removeIcon_i56hf_61",
  "status": "_status_i56hf_65",
  "allocations": "_allocations_i56hf_72",
  "text": "_text_i56hf_79",
  "tick": "_tick_i56hf_85",
  "late": "_late_i56hf_92",
  "completed": "_completed_i56hf_96",
  "displayContextualMenu": "_displayContextualMenu_i56hf_107",
  "placeholder": "_placeholder_i56hf_111"
};